import Vue from "vue";
import * as subfixFunc from "@/vuex/subfix";
import http from '@/fetch/http';
import httpExercisesBasket from '@/fetch/http-exercises-basket';
import {t} from "../../components/common/element-ui/src/locale";
// 资源展示区分--授课
const RES_DIFF_TEACHING = "teaching";
// 关闭资源
const RES_CLOSING = "closing";

// 试题
const RES_PAPER = "paper";
const state = {
  serverIp: '',
  exerciseCount: '',
  clickExerBasketFlag: false,
  noviceGuidanceFlag: true,
    // 新手指引 点击展开
    noviceNewFlag: false,
  websocketUrl: '',
  // header 三级名称 四级名称
  headerthree: '',
  headerfour: false,
  // header dropwindow
  showDropWindow: false,
  // 涂鸦板
  showgraffiti: true,
  // 图片 视频 pdf预览
  // Viewmodal.vue
  viewmodalFlag: false,
  viewmodalimgFlag: false,
  viewmodalvideoFlag: false,
  viewmodalswfFlag: false,
  viewmodalpdfFlag: false,
  viewmodalpaperFlag: false,

  //授课ppt img video swf
  logimgmodalFlag: false,
  logvideomodalFlag: false,
  logswfmodalFlag: false,
  //授课ppt doc
  logpdfmodalFlag: false,
  //授课游戏
  loggamemodalFlag: false,
  // 试题浏览
  logAnswerFlag: false,
  // 是否显示答案
  logShowAnswerFlag: false,
  // 组卷modal
  papermodalFlag: false,
  // 试卷
  papermodalcreateFlag: false,
  //试题列表title状态
  paperListFlag: false,

  //显示加载信息
  showLoading: false,
  // 授课ppt v-if
  impressremain: false,
  //页面
  pageStack: [
    '/home/homelist'
  ],
  pageReturn: '',
  //组卷paperBankId
  paperBankId: 0,
  res_closing: "closing",
  res_diff_teaching: "teaching",
  res_paper: 'paper',
  // 进入页面 小程序 or 正常
  autoLoginToken: ''
}

const actions = {
  setServerIp({commit}, url){
    commit('SET_SERVER_IP', url)
  },
  setExerciseCount({commit}, url) {
      httpExercisesBasket.getExerciseBasketCount().then(res => {
          commit('SET_EXERCISE_COUNT', res.data);
      })
  },
  setClickExerBasketFlag({commit}, flag) {
    commit('SET_CILCK_EXER_BASKET_FLAG', flag);
  },
  setWebsocketUrl({commit}, url){
    commit('SET_WEBSOCKET_URL', url)
  },
  // header 名称
  setHeaderThree({commit}, flag) {
    commit('setheaderthree', flag)
  },
  setHeaderFour({commit}, flag) {
    commit('setheaderfour', flag)
  },
  // header 下拉列表
  showDropWindow({commit}, flag) {
    commit('showdropwindow', flag)
  },
  // 涂鸦板
  showGraffiti({commit}, flag) {
    commit('showgraffiti', flag)
  },
  // 图片 视频 pdf预览
  showViewmodal({commit}, param) {
    commit('showViewmodal', param)
  },
  // 组卷modal
  showPapermodal({commit}, flag) {
    commit('papermodalFlag', flag)
    // commit('PAPER_BANK_ID', param.bankId)
    // commit('papermodalFlag', param.flag),
    // commit('PAPER_BANK_ID', param.bankId)
  },
  //加载信息
  setLoading({commit}, flag) {
    commit('SET_LOADING', flag)
  },
  // 授课ppt v-if
  setImpressRemain({commit}, remain){
    commit('SET_IMPRESS_REMAIN', remain)
  },
  changeLogShowAnswerFlag({commit}, flag) {
	commit('changeLogShowAnswerFlag', flag);
  },
  setNoviceFlag({commit},flag){
      commit('SET_NOVICE_FLG',flag)
  },
  setNoviceNewFlag({commit},flag){
    commit('SET_NOVICE_NEW_FLG',flag)
  },
  setAutoLoginToken({commit},flag){
    commit('SET_AUTO_LOGIN_TOKEN',flag)
  }
}

const mutations = {
  ["SET_SERVER_IP"](state, url){
    Vue.set(state, 'serverIp', url);
  },
  ["SET_EXERCISE_COUNT"](state, url){
    Vue.set(state, 'exerciseCount', url);
  },
  ["SET_WEBSOCKET_URL"](state, url){
    Vue.set(state, 'websocketUrl', url);
  },
  ["SET_NOVICE_FLG"](state, value){
      state.noviceGuidanceFlag = value;
  },
  ["SET_NOVICE_NEW_FLG"](state, value){
      state.noviceNewFlag = value;
  },
  ["SET_AUTO_LOGIN_TOKEN"](state, value){
      state.autoLoginToken = value;
  },
  setheaderthree(state, flag) {
    state.headerthree = flag;
  },
  ["SET_CILCK_EXER_BASKET_FLAG"](state, flag) {
    state.clickExerBasketFlag = flag;
  },
  setheaderfour(state, flag) {
    if (flag == 1) {
      state.headerfour = flag;
    } else if (flag == 2) {
      state.headerfour = flag;
    } else {
      state.headerfour = 0;
    }
  },
  //加载信息
  ["SET_LOADING"](state, flag) {
    if (flag == 1) {
      Vue.set(state, 'showLoading', true);
    } else {
      Vue.set(state, 'showLoading', false);
    }
  },
  //组卷的id
  ['PAPER_BANK_ID'](state, paperBankId){
    Vue.set(state, 'paperBankId', paperBankId);
  },
  // 授课ppt v-if
  ['SET_IMPRESS_REMAIN'](state, remain){
    Vue.set(state, 'impressremain', remain);
  },
  // header 下拉列表
  showdropwindow(state, flag) {
    if (flag == 1) {
      state.showDropWindow = true;
    } else {
      state.showDropWindow = false;
    }
  },
  // 涂鸦板
  showgraffiti(state, flag) {
    state.showgraffiti = flag;
  },
  // 浏览资源
  showViewmodal(state, param) {
    // 关闭
    if (param.subfix == RES_CLOSING) {
      state.viewmodalFlag = false;

      state.logimgmodalFlag = false;
      state.logvideomodalFlag = false,
        state.logswfmodalFlag = false,
        state.logpdfmodalFlag = false;
      state.loggamemodalFlag = false;

      state.viewmodalimgFlag = false;
      state.viewmodalvideoFlag = false;
      state.viewmodalswfFlag = false;
      state.viewmodalpdfFlag = false;

      state.logAnswerFlag = false;
      state.viewmodalpaperFlag = false;
      return false;
    }
    // 非授课状态
    if (param.diff != RES_DIFF_TEACHING) {
      // 以图片形式播放
      if (subfixFunc.play_with_img(param.subfix)) {
        state.viewmodalFlag = true;
        state.viewmodalimgFlag = true;
        state.viewmodalvideoFlag = false;
        state.viewmodalswfFlag = false;
        state.viewmodalpdfFlag = false;
        return false;
      }
      // 以视频形式播放
      if (subfixFunc.play_with_video(param.subfix)) {
        state.viewmodalFlag = true;
        state.viewmodalvideoFlag = true;
        state.viewmodalimgFlag = false;
        state.viewmodalswfFlag = false;
        state.viewmodalpdfFlag = false;
        return false;
      }
      // 以flash形式播放
      if (subfixFunc.play_with_flash(param.subfix)) {
        state.viewmodalFlag = true;
        state.viewmodalswfFlag = true;
        state.viewmodalimgFlag = false;
        state.viewmodalvideoFlag = false;
        state.viewmodalpdfFlag = false;
        return false;
      }
      // 以pdf形式播放
      if (subfixFunc.play_with_pdf(param.subfix)) {
        state.viewmodalFlag = true;
        state.viewmodalpdfFlag = true;
        state.viewmodalimgFlag = false;
        state.viewmodalvideoFlag = false;
        state.viewmodalswfFlag = false;
        return false;
      }
      // 授课
    } else {
      // 授课 以图片形式播放
      if (subfixFunc.play_with_img(param.subfix)) {
        state.logimgmodalFlag = true;
        state.viewmodalFlag = true;
        return false;
      }
      // 授课 以swf形式播放
      if (subfixFunc.play_with_flash(param.subfix)) {
        state.logswfmodalFlag = true;
        state.viewmodalFlag = true;
        return false;
      }
      // 授课 以video形式播放
      if (subfixFunc.play_with_video(param.subfix)) {
        state.logvideomodalFlag = true;
        state.viewmodalFlag = true;
        return false;
      }
      // 授课 以ppt形式播放
      if (subfixFunc.play_with_pdf(param.subfix)) {
        state.logpdfmodalFlag = true;
        state.viewmodalFlag = true;
        return false;
      }
      // 授课 以游戏形式播放
      if (subfixFunc.play_with_game(param.subfix)) {
        state.loggamemodalFlag = true;
        state.viewmodalFlag = true;
        return false;
      }
    }

    if (param.subfix == RES_PAPER) {
      state.viewmodalFlag = true;
      state.viewmodalpaperFlag = true;
      return false;
    }
    if (param.subfix == 'loganswer') {
      state.viewmodalFlag = true;
      state.logAnswerFlag = true;
      return false;
    }
  },

  // 组卷modal
  papermodalFlag(state, flag) {
    // flag 0 关闭
    if (flag == 0) {
      state.papermodalFlag = false;
      state.papermodalcreateFlag = false;
    }
    if (flag == 1) {
      state.papermodalFlag = true;
      state.papermodalcreateFlag = true;
    }
  },
  changeLogShowAnswerFlag(state, flag) {
	  state.logShowAnswerFlag = flag;
  }
}
const getters = {
  // 涂鸦板
  // showState(state) {
  // 	console.log(state.headerInfo)
  // },
  showLoading: function (state) {
    return state.showLoading;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/status.js